import { render, staticRenderFns } from "./MessageTextArea.vue?vue&type=template&id=7801642e&"
import script from "./MessageTextArea.vue?vue&type=script&lang=js&"
export * from "./MessageTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports